import type { DashboardDatePreset, DashboardDateRange } from '@/lib/campaign-dashboard'
import styles from './CampaignDashboard.module.css'

interface CampaignDashboardFiltersProps {
  value: DashboardDateRange
  draftDateFrom: string
  draftDateTo: string
  onPresetChange: (preset: Exclude<DashboardDatePreset, 'custom'>) => void
  onDraftDateChange: (field: 'dateFrom' | 'dateTo', value: string) => void
  onApplyCustomRange: () => void
}

const PRESET_OPTIONS: Array<{
  value: Exclude<DashboardDatePreset, 'custom'>
  label: string
}> = [
  { value: '7d', label: '7 dias' },
  { value: '30d', label: '30 dias' },
  { value: 'month', label: 'Mês atual' },
  { value: 'all', label: 'Todo o período' },
]

export function CampaignDashboardFilters({
  value,
  draftDateFrom,
  draftDateTo,
  onPresetChange,
  onDraftDateChange,
  onApplyCustomRange,
}: CampaignDashboardFiltersProps) {
  return (
    <div className={styles.chartToolbar}>
      <div className={styles.filtersBar}>
        <div className={styles.filtersGroup}>
          <span className={styles.filtersLabel}>Período do dashboard</span>
          <div className={styles.filterChips} role="group" aria-label="Período do dashboard">
            {PRESET_OPTIONS.map((option) => {
              const className =
                value.preset === option.value ? styles.filterChipActive : styles.filterChip

              return (
                <button
                  key={option.value}
                  type="button"
                  className={className}
                  aria-pressed={value.preset === option.value}
                  onClick={() => onPresetChange(option.value)}
                >
                  {option.label}
                </button>
              )
            })}
          </div>
        </div>

        <div className={styles.customFilters}>
          <div className={styles.fieldGroup}>
            <label htmlFor="dashboard-date-from">De</label>
            <input
              id="dashboard-date-from"
              type="date"
              className={styles.dateInput}
              value={draftDateFrom}
              onChange={(event) => onDraftDateChange('dateFrom', event.target.value)}
            />
          </div>

          <div className={styles.fieldGroup}>
            <label htmlFor="dashboard-date-to">Até</label>
            <input
              id="dashboard-date-to"
              type="date"
              className={styles.dateInput}
              value={draftDateTo}
              onChange={(event) => onDraftDateChange('dateTo', event.target.value)}
            />
          </div>

          <button
            type="button"
            className={styles.actionButton}
            onClick={onApplyCustomRange}
            disabled={!draftDateFrom || !draftDateTo}
          >
            Aplicar
          </button>
        </div>
      </div>
    </div>
  )
}
